/* assets/sections-safe.js */
/* HyperSpeed-safe global handlers for section components */

(() => {
  if (window.__searchBarGlobalOutsideClickInit) return;
  window.__searchBarGlobalOutsideClickInit = true;

  document.addEventListener('click', (event) => {
    const bars = document.querySelectorAll('[data-search-bar]');
    bars.forEach((el) => {
      if (el.contains(event.target)) return;

      // Call whichever method exists on that component
      if (typeof el.hideSuggestions === 'function') el.hideSuggestions();
      if (typeof el.hideResults === 'function') el.hideResults();
    });
  });
})();

(() => {
  /* Global music player / music player click delegation */
  if (window.__ssMusicPlayerInit) return;
  window.__ssMusicPlayerInit = true;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-music-player-toggle]');
    if (!btn) return;

    const root = btn.closest('.music-player');
    if (!root) return;

    const audio = root.querySelector('.music-player__audio');
    if (!audio) return;

    /* Store playing state on the audio element itself */
    const isPlaying = audio.__playing;
    if (isPlaying) {
      audio.pause();
      audio.__playing = false;
      btn.classList.remove('music-player__btn--playing');
      btn.classList.add('music-player__btn--paused');
    } else {
      audio.play();
      audio.__playing = true;
      btn.classList.remove('music-player__btn--paused');
      btn.classList.add('music-player__btn--playing');
    }
  });
})();

(() => {
  /* Scroll-to-top button */
  if (window.__scrollTopInit) return;
  window.__scrollTopInit = true;

  const onScroll = () => {
    document.querySelectorAll('[data-scroll-to-top]').forEach((btn) => {
      const threshold = parseInt(btn.dataset.displayAfter, 10) || 0;
      if (threshold === 0) return;
      btn.style.display = window.scrollY > threshold ? '' : 'none';
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-scroll-to-top]');
    if (!btn) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

(() => {
  /* Announcement bar: copy code buttons */
  if (window.__announcementCopyInit) return;
  window.__announcementCopyInit = true;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-copy-code]');
    if (!btn) return;

    const code = btn.dataset.code;
    if (!code) return;

    navigator.clipboard.writeText(code.trim());
    btn.classList.add('success');
    setTimeout(() => {
      btn.classList.remove('success');
    }, 2000);
  });
})();

(() => {
  /* Promo popup: show + close success modal after subscription */
  if (window.__promoPopupSuccessInit) return;
  window.__promoPopupSuccessInit = true;

  const storageKey = `promo-bar-subscribed-${window.location.host}`;

  const initSuccessForRoot = (root, { allowRepeat } = {}) => {
    if (!root) return;

    const overlay = root.querySelector('[data-success-popup-overlay]') || root.querySelector('.success-popup-overlay');
    const modal = root.querySelector('[data-success-popup-modal]') || root.querySelector('.success-popup-modal');
    if (!modal) return;

    if (!allowRepeat) {
      try {
        if (localStorage.getItem(storageKey)) return;
      } catch (_) {
        // ignore storage errors
      }
    }

    try {
      localStorage.setItem(storageKey, JSON.stringify({ subscribed: true }));
    } catch (_) {
      // ignore storage errors
    }

    modal.classList.add('popup-modal--active');
    if (overlay) overlay.classList.add('popup-overlay--active');
  };

  const tryInit = () => {
    document.querySelectorAll('[data-promo-popup-success]').forEach((trigger) => {
      if (trigger.dataset.init === '1') return;
      trigger.dataset.init = '1';

      const root = trigger.closest('[data-section-id]') || document;
      const allowRepeat = trigger.dataset.successTesting === 'true';
      initSuccessForRoot(root, { allowRepeat });
    });
  };

  // Run once for initial page load
  tryInit();

  // Also handle HyperSpeed / dynamic injection by observing DOM
  const mo = new MutationObserver(() => tryInit());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Close buttons + overlay click (delegated)
  document.addEventListener('click', (e) => {
    const closeEl = e.target.closest('[data-success-popup-close],[data-success-popup-overlay]');
    if (!closeEl) return;

    const root = closeEl.closest('[data-section-id]') || document;
    const overlay = root.querySelector('[data-success-popup-overlay]') || root.querySelector('.success-popup-overlay');
    const modal = root.querySelector('[data-success-popup-modal]') || root.querySelector('.success-popup-modal');
    if (modal) modal.classList.remove('popup-modal--active');
    if (overlay) overlay.classList.remove('popup-overlay--active');
  });
})();

(() => {
  /* Size guide: unit + type toggles (mlc-sizeguide) */
  if (window.__mlcSizeGuideInit) return;
  window.__mlcSizeGuideInit = true;

  const root = () => document.getElementById('mlc-sizeguide');
  let isClickBound = false;
  let sizeGuideObserver = null;

  const safeLSGet = (key) => {
    try {
      return localStorage.getItem(key);
    } catch (_) {
      return null;
    }
  };

  const safeLSSet = (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (_) {
      // ignore storage errors
    }
  };

  const setUnit = (unit) => {
    const r = root();
    if (!r) return;

    const btnIn = r.querySelector('#mlcUnitIn');
    const btnCm = r.querySelector('#mlcUnitCm');
    if (btnIn) btnIn.setAttribute('aria-pressed', unit === 'in' ? 'true' : 'false');
    if (btnCm) btnCm.setAttribute('aria-pressed', unit === 'cm' ? 'true' : 'false');

    r.querySelectorAll('[data-sg-unit]').forEach((el) => {
      el.style.display = el.getAttribute('data-sg-unit') === unit ? '' : 'none';
    });

    safeLSSet('mlc_sg_unit', unit);
  };

  const setType = (sectionName, type) => {
    const r = root();
    if (!r) return;

    const section = r.querySelector(`[data-sg-section="${sectionName}"]`);
    if (!section) return;

    section.querySelectorAll('.sg-chooser button[data-sg-type]').forEach((b) => {
      b.setAttribute('aria-pressed', b.getAttribute('data-sg-type') === type ? 'true' : 'false');
    });

    section.querySelectorAll('.sg-block[data-sg-type]').forEach((block) => {
      block.style.display = block.getAttribute('data-sg-type') === type ? '' : 'none';
    });

    safeLSSet(`mlc_sg_type_${sectionName}`, type);
  };

  const handleClick = (e) => {
    const r = root();
    if (!r) return;

    const inBtn = e.target.closest('#mlcUnitIn');
    const cmBtn = e.target.closest('#mlcUnitCm');
    if (inBtn && r.contains(inBtn)) {
      e.preventDefault();
      setUnit('in');
      return;
    }
    if (cmBtn && r.contains(cmBtn)) {
      e.preventDefault();
      setUnit('cm');
      return;
    }

    const chooserBtn = e.target.closest('.sg-chooser button[data-sg-type]');
    if (chooserBtn && r.contains(chooserBtn)) {
      e.preventDefault();
      const section = chooserBtn.closest('[data-sg-section]');
      if (!section) return;
      setType(section.getAttribute('data-sg-section'), chooserBtn.getAttribute('data-sg-type'));
      return;
    }

    const navLink = e.target.closest('.sg-pillnav a[href^="#"]');
    if (navLink && r.contains(navLink)) {
      const sel = navLink.getAttribute('href');
      const target = document.querySelector(sel);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const init = () => {
    const r = root();
    if (!r) return false;
    if (!isClickBound) {
      document.addEventListener('click', handleClick);
      isClickBound = true;
    }
    if (r.dataset.sgInitialized === 'true') return true;
    r.dataset.sgInitialized = 'true';

    const savedUnit = safeLSGet('mlc_sg_unit');
    setUnit(savedUnit === 'cm' ? 'cm' : 'in');

    const clothingType = safeLSGet('mlc_sg_type_clothing') || 'clothing-dresses-tops';
    const jewelryType = safeLSGet('mlc_sg_type_jewelry') || 'jewelry-rings';
    setType('clothing', clothingType);
    setType('jewelry', jewelryType);
    return true;
  };

  const observeSizeGuide = () => {
    if (sizeGuideObserver) return;

    sizeGuideObserver = new MutationObserver(() => {
      if (!init()) return;
    });

    sizeGuideObserver.observe(document.documentElement, { childList: true, subtree: true });
  };

  const boot = () => {
    if (init()) {
      observeSizeGuide();
      return;
    }

    observeSizeGuide();
  };

  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', boot, { once: true });
    return;
  }

  boot();
})();

(() => {
  /* Shopify privacy banner: persist “accept” in localStorage so the bar stays dismissed across visits */
  if (window.__mlcShopifyCookieConsentInit) return;
  window.__mlcShopifyCookieConsentInit = true;

  const STORAGE_KEY = 'mlc_shop_cookie_consent';

  const markAccepted = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch (_) {
      /* ignore quota / private mode */
    }
    document.documentElement.classList.add('mlc-shop-cookie-accepted');
  };

  document.addEventListener(
    'click',
    (e) => {
      if (window.Shopify && window.Shopify.designMode) return;
      const t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      const btn = t.closest(
        '.shopify-privacy-banner button[data-testid="accept-button"], #shopify-pc__banner__btn-accept, .shopify-pc__banner__btn-accept'
      );
      if (!btn) return;
      markAccepted();
    },
    true
  );
})();
